import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Main from '../../components/Main/Main.jsx';
import ListaArvoreLinhas from '../../components/Listas/ListaArvoreLinhas.jsx';
import {
  getArvoreLinhas,
  getSearchMaquinario,
  resetArvore,
  resetSearch,
} from '../../slices/arvoreSlice.js';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import InputSearchArvore from '../../components/Inputs/InputSearchArvore.jsx';
import Title from '../../components/Title.jsx';
import usePageTitle from '../../hook/usePageTitle.js';

const ArvoresPecas = () => {
  usePageTitle();
  const param = useParams();
  const { arvoreLinhas, searchMaquinario } = useSelector((state) => state.arvore);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    return () => dispatch(resetSearch());
  }, [dispatch]);

  const handlenavigate = (e) => {
    e.preventDefault();
    const tag = e.target[0].value;
    dispatch(getSearchMaquinario(tag.toLowerCase()));
  };

  useEffect(() => {
    if (searchMaquinario.nome) {
      const { nome, tag } = searchMaquinario;
      navigate(`/arvore-peças/${tag}/${nome}`);
    }
    if (searchMaquinario == 'notFound') {
      navigate(`/arvore-peças/nao Encontrado/-`);
    }
  }, [searchMaquinario]);

  useEffect(() => {
    dispatch(getArvoreLinhas());
    return () => dispatch(resetArvore());
  }, [dispatch]);

  useEffect(() => {
    if (param) {
      const element = document.getElementById('top');
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }, [param]);

  return (
    <Main>
      <div className="mt-0 flex mb-3 flex-wrap">
        <Title>Locais de aplicaçao</Title>
        <InputSearchArvore handleSubmit={handlenavigate} />
      </div>
      <section className="z-0 flex md:h-[80vh] gap-4 flex-col-reverse lg:flex-row">
        <div className=" dark:bg-darkColorBox w-full lg:w-[50%] p-5 rounded-md overflow-auto space-y-0  shadow-darkShadow global-scrollbar">
          <ListaArvoreLinhas linha={arvoreLinhas} />
        </div>
        <div
          id="top"
          className="mx-auto w-full md:w-full md:h-auto lg:h-full overflow-hidden shadow-darkShadow "
        >
          <Outlet />
        </div>
      </section>
    </Main>
  );
};

export default ArvoresPecas;
